import React, { FC } from 'react';
import classnames from 'classnames';
import './index.less';

const Torch: FC<{ id?: string }> = ({ id }) => {
  return <div className="torch-animate" id={id} />;
};

export default Torch;
